import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { Autocomplete, ListItem, TextField } from "@material-ui/core";
import _noop from "lodash.noop";

FieldLimitedAutocompleteLegalEntity.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  helperText: PropTypes.node,
  inputRef: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.object,
};
export default function FieldLimitedAutocompleteLegalEntity({
  defaultValue,
  disabled = false,
  helperText,
  inputRef,
  onBlur = _noop,
  onChange = _noop,
  options,
  ...props
}) {
  const {
    entities,
    lists,
    user,
  } = options;

  const [value, setValue] = React.useState(null);

  useEffect(() => {
    onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  function handleChange(event, newOption) {
    if (newOption) {
      setValue(newOption);
    } else {
      setValue(null);
    }
  }

  useEffect(() => {
    if (user?.confirmedEntitiesIds?.length === 1) {
      handleChange('', user.confirmedEntitiesIds[0])
    }
  }, [user?.confirmedEntitiesIds])

  return (
    <Autocomplete
      autoComplete
      autoHighlight
      disableClearable
      disabled={disabled}
      getOptionLabel={(option) => entities.legalEntities.data[option].shortLegalName}
      onChange={handleChange}
      options={lists.legalEntities}
      renderInput={(params, value) => {
        return (
          <TextField
            {...props}
            {...params}
            fullWidth
            helperText={helperText || (value ? `ИНН: ${value}` : "")}
            sx={{ mb: 3 }}
            variant="filled"
          />
        )
      }}
      renderOption={(props, option) => {
        return (
          <ListItem {...props} dense>
            {entities.legalEntities.data[option].shortLegalName}
          </ListItem>
        );
      }}
      sx={{ width: 1 }}
      value={value}
    />
  );
}
